import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { acPopVizibil } from '../actions/acPopVizibil'
import { acMobToggle } from '../actions/acMobToggle';
import { acConSizeChange } from '../actions/acConSizeChange';

import BiletItem from '../containers/BiletItem'
import TopWiners from '../containers/TopWiners';
import WidgetPromotie from '../containers/WidgetPromotie';
import WidgetPromotieLastResults from '../containers/WidgetPromotieLastResults';

class ColoanaDr extends React.Component {

    constructor() {
        super();
        this.state = { height: 0 };
    }

    componentDidMount() {
        if (this.refColDr) {
            var height = this.refColDr.offsetHeight// + 100
            this.props.acConSizeChange({ colDr: height })
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.refColDr) {
            var height = this.refColDr.offsetHeight// + 100
            if (this.props.conSizeChange.colDr && height && this.props.conSizeChange.colDr !== height) {
                this.props.acConSizeChange({ colDr: height })
            }
        }
    }
    colDrMid() {
        if (this.props.bilete) {
            return <BiletItem />
        } else {
            return (
                <div className='con-bilet'>
                    <div className='zero-bilete'>{this.props.multiLang.bilete0.txt}</div>
                </div>
            )
        }
    }

    popUpRunde(e) {
        this.props.acPopVizibil({
            vizibil: true,
            position: { x: 'auto', y: 100 },
            info: { type: 'runde' }
        })

    }
    popUpPariuri() {
        this.props.acPopVizibil({
            vizibil: true,
            position: { x: 'auto', y: 100 },
            info: { type: 'pariuri' }
        })
    }
    toggleMobile() {
        if (this.props.mobToggle === true) {
            return 'mob'
        } else {
            return ''
        }
    }
    topWiners() {
        if (this.props.appProps.topWiners === true) {
            return (
                <div>
                    <TopWiners />
                </div>
            )
        } else {
            return ''
        }
    }
    toggleOverlay() {
        this.props.acMobToggle(!this.props.mobToggle)
    }
    istoricPariuri() {
        if (this.props.defaultVal.mode !== 'demo') {
            return <div className="istoric-pariuri" onClick={this.popUpPariuri.bind(this)}>{this.props.multiLang.istoricBilete.txt}</div>
        }
    }
    popUpOficialLinks(e) {
        this.props.acPopVizibil({
            vizibil: true,
            position: { x: 'auto', y: 100 },
            info: { type: 'oficialLinks' }
        })
        e.stopPropagation();
    }
    render() {
        if (this.props.multiLang !== null) {
            return (
                <div className={'col-dr ' + this.toggleMobile()} ref={(f) => this.refColDr = f} >
                    <div className="mob-overlay" onClick={this.toggleOverlay.bind(this)}></div>
                    <div className="module-header">
                        <div>
                            <span>{this.props.multiLang.headerDr.txt}</span>
                        </div>
                    </div>
                    {this.colDrMid()}
                    <div className="istoric-runde" onClick={this.popUpRunde.bind(this)}>{this.props.multiLang.istoricRunde.txt}</div>
                    {(this.props.appProps.oficialLinks === true) ? <div className={"oficial_links " + this.props.defaultVal.mode} onClick={this.popUpOficialLinks.bind(this)}>{this.props.multiLang.oficialLinks.txt}</div> : null}
                    {this.istoricPariuri()}
                    {this.props.appProps.topWiners && !this.props.appProps.widgetPromo ? this.topWiners() : null}
                    {this.props.conSizeChange && this.props.conSizeChange.appW >= 1000 && this.props.appProps.widgetPromo ? <WidgetPromotie /> : null}
                    {this.props.conSizeChange?.appW >= 1000 && this.props.appProps?.widgetPromo && this.props?.widgetPromotie?.lastResults?.length >= 3 ? <WidgetPromotieLastResults /> : null}
                </div>
            )
        } else {
            return <div></div>
        }
    }
}
function mapStateToProps(state) {
    return {
        appProps: state.appProps,
        bilete: state.bilete,
        multiLang: state.multiLang,
        activeLot: state.activeLot,
        mobToggle: state.mobToggle,
        conSizeChange: state.conSizeChange,
        defaultVal: state.defaultVal,
        widgetPromotie: state.widgetPromotie
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acPopVizibil: acPopVizibil,
        acMobToggle: acMobToggle,
        acConSizeChange: acConSizeChange
        // acAxiosRequest: acAxiosRequest,
        // acToggleMobile: acToggleMobile,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ColoanaDr);
